export const basicSkipLinks = ['content', 'searchBarSelect']

export const catalogOverviewSkipLinks = [
  'searchHit',
  'pageNav',
  'filterOptions',
  // TODO: activate once catalog has searchbar
  // 'searchBarSelect',
]

export const homeSkipLinks = [
  'searchBarSelect',
  'sideBarMenu',
  'languageSwitch',
  'accessibility',
  'gallery',
]

export const searchOverviewSkipLinks = [
  'searchHit',
  'pageNav',
  'filterOptions',
  'searchBarSelect',
]

export const searchDetailPageSkipLinks = [
  'content',
  'hsp-descriptions',
  'hsp-digitizeds',
  'resultNav',
]

export const projectOverviewSkipLinks = ['flipcard', 'searchBarSelect']
